(() => {
  "use strict";

  window.zag = window.zag || {};

  window.zag.components.ZagCustomPopin = class extends (
    window.zag.components.ZagComponent
  ) {
    connectedCallback() {
      this.events.add(this.section, "click", (event) => {
        if (event.target == this.section) {
          this.dismiss();
        }
      });

      this.events.add(this.closeButton, "click", this.dismiss);

      if (this.readButton) {
        this.events.add(this.readButton, "click", this.dismiss);
      }

      this.events.add(window, "scroll", this.onScroll, { passive: true });

      this.checkAndShow();
    }

    get overlay() {
      return this.cache.get("dom", "overlay", () => {
        return this.querySelector(".popin-overlay");
      });
    }

    get closeButton() {
      return this.cache.get("dom", "closeButton", () => {
        return this.querySelector(".popin-close");
      });
    }

    get readButton() {
      return this.cache.get("dom", "readButton", () => {
        return this.querySelector(".popin-read-button");
      });
    }

    get appearanceDelay() {
      return this.cache.get("dom", "appearanceDelay", () => {
        return (
          this.modifiers
            .list()
            .find((modifier) => modifier.startsWith("appearance-delay:"))
            ?.split(":")[1] || 0
        );
      });
    }

    get cookieExpiryDays() {
      return parseInt(this.dataset.cookieExpiry ?? 30);
    }

    // Cookie persistant : posé à la fermeture, bloque toute réapparition
    get dismissedCookieKey() {
      return `zag_cp_${this.id}_dismissed`;
    }

    // Cookie de session : posé à l'affichage, unique par page
    get pageCookieKey() {
      const path = window.location.pathname.replace(/\//g, "_");
      return `zag_cp_${this.id}_page${path}`;
    }

    getCookie(name) {
      const match = document.cookie
        .split("; ")
        .find((row) => row.startsWith(`${name}=`));
      return match ? match.split("=")[1] : null;
    }

    setCookie(name, value, days = null) {
      let expires = "";
      if (days !== null) {
        const d = days === 0 ? 3650 : days;
        expires = `; expires=${new Date(Date.now() + d * 24 * 60 * 60 * 1000).toUTCString()}`;
      }
      // Sans expires = cookie de session, supprimé à la fermeture du navigateur
      document.cookie = `${name}=${value}${expires}; path=/; SameSite=Lax`;
    }

    checkAndShow = () => {
      // L'utilisateur a déjà fermé/cliqué la popin → on ne réaffiche plus
      if (this.getCookie(this.dismissedCookieKey) === "true") return;

      // La popin a déjà été vue sur cette page durant cette session
      if (this.getCookie(this.pageCookieKey) === "seen") return;

      const delay = parseInt(this.appearanceDelay);
      if (delay === 0) {
        // Delay 0 = désactivé
        return;
      }

      setTimeout(() => {
        this.show();
        // On pose le cookie de session pour cette page
        this.setCookie(this.pageCookieKey, "seen");
      }, delay * 1000);
    };

    onScroll = () => {
      if (!this.modifiers.list().includes("popin-open")) return;

      const scrollY = window.scrollY;
      const fadeDistance = 200;
      const opacity = Math.max(0, 1 - scrollY / fadeDistance);

      this.overlay.style.setProperty("--overlay-opacity", opacity);
    };

    show = () => {
      this.modifiers.add("popin-open");
    };

    hide = () => {
      this.modifiers.remove("popin-open");
    };

    // Fermeture définitive : pose le cookie persistant puis cache
    dismiss = () => {
      this.setCookie(this.dismissedCookieKey, "true", this.cookieExpiryDays);
      this.hide();
    };
  };

  if (!window.customElements.get("zag-custom-popin")) {
    window.customElements.define(
      "zag-custom-popin",
      window.zag.components.ZagCustomPopin
    );
  }
})();
